/* Measure the native gallery for CSS sticking; never move or clone product media. */
if (!customElements.get('divine-gallery-follow')) {
  customElements.define('divine-gallery-follow', class extends HTMLElement {
    connectedCallback() {
      if (this.connected || this.dataset.follow !== 'true' || !['thumbnail', 'thumbnail_slider'].includes(this.dataset.layout)) return;
      this.gallery = this.querySelector('media-gallery');
      if (!this.gallery) return;
      this.connected = true;
      this.measure = () => {
        const height = Math.ceil(this.gallery.getBoundingClientRect().height);
        if (height > 0 && height !== this.measuredHeight) {
          this.measuredHeight = height;
          this.style.setProperty('--dd-gallery-block-size', `${height}px`);
        }
      };
      this.measure();
      if (typeof ResizeObserver !== 'undefined') {
        this.observer = new ResizeObserver(this.measure);
        this.observer.observe(this.gallery);
      } else {
        window.addEventListener('resize', this.measure);
      }
      this.addEventListener('load', this.measure, true);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.measure) {
        window.removeEventListener('resize', this.measure);
        this.removeEventListener('load', this.measure, true);
      }
      this.connected = false;
      this.measuredHeight = null;
      this.style.removeProperty('--dd-gallery-block-size');
    }
  });
}
